// Close mega menu on scroll
(function() {
  'use strict';
  
  let scrollTimeout;
  
  // Close all open details/dropdowns when user scrolls
  window.addEventListener('scroll', function() {
    // Clear any existing timeout
    clearTimeout(scrollTimeout);
    
    // Wait for scroll to settle (debounce)
    scrollTimeout = setTimeout(function() {
      // Find all open details elements
      const openMenus = document.querySelectorAll('.header__inline-menu details[open]');
      
      // Close each open menu
      openMenus.forEach(function(menu) {
        menu.removeAttribute('open');
      });
    }, 50); // 50ms delay
  });
})();